<ng-container *ngIf="!groupByFn">
    <ng-select *ngIf="items"
               [placeholder]="placeholder"
               [items]="items"
               [bindLabel]="'__label'"
               [ngModel]="selection"
               [disabled]="disabled"
               [required]="required"
               [multiple]="multiple"
               [clearable]="clearable"
               (clear)="onChange(null)"
               [appendTo]="appendTo"
               [compareWith]="compareFn"
               (ngModelChange)="onChange($event)"
               [addTag]="addTag"
               [addTagText]="addTagText">
    </ng-select>
</ng-container>
<ng-container *ngIf="groupByFn">
    <ng-select *ngIf="items"
               [placeholder]="placeholder"
               [items]="items"
               [bindLabel]="'__label'"
               [ngModel]="selection"
               [required]="required"
               [disabled]="disabled"
               [multiple]="multiple"
               [clearable]="false"
               [appendTo]="appendTo"
               (clear)="onChange(null)"
               [compareWith]="compareFn"
               [groupBy]="groupByFn"
               [groupValue]="groupValueFn"
               (ngModelChange)="onChange($event)"
               [addTag]="addTag"
               [addTagText]="addTagText">
        <ng-template ng-optgroup-tmp let-item="item">
            <span style="vertical-align: middle;">{{item.name}} ({{ item.total }})</span>
        </ng-template>
    </ng-select>
</ng-container>
